define(["require", "exports", "vue"], function (require, exports, vue_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var NumericInputComponent = (function () {
        function NumericInputComponent() {
            vue_1.default.component('number-input', {
                template: '<input v-on:change="update" v-on:keyup.enter="update" v-model="val" type="number" />',
                props: {
                    localValue: Number
                },
                watch: {
                    localValue: function (propValue) {
                        this.val = propValue;
                    }
                },
                data: function () {
                    return { val: 0 };
                },
                methods: {
                    update: function (event) {
                        console.log(this.val);
                        this.$emit('update', this, this.val);
                    }
                }
            });
        }
        return NumericInputComponent;
    }());
    exports.NumericInputComponent = NumericInputComponent;
});
//# sourceMappingURL=NumericInputComponent.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Components/NumericInputComponent.js
// module id = 105
// module chunks = 0